import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import SingleColumn from "../components/content/single-column"

import "prismjs/themes/prism-okaidia.css"
import "./secondary.css"

import Hero from "../components/hero"
import { MDXRenderer } from "gatsby-plugin-mdx"

const MainPage = ({ data, location }) => {
  const post = data.mdx
  return (
    <Layout location={location}>
      <SEO title={post.frontmatter.title} {...post.frontmatter} />
      <div className="full_width">
        <div className="full_width_inner">
          <Hero {...post.frontmatter} />
          <SingleColumn>
            <MDXRenderer>{post.body}</MDXRenderer>
          </SingleColumn>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        slug
        title
        template
        heroVideoURL
        heroBackgroundImage {
          data: childImageSharp {
            resolutions(width: 1200) {
              width
              height
              src
              srcSet
            }
          }
          publicURL
          relativePath
          dev
          base
        }
        heroH1
        heroH2
        heroText
        heroCTAText
        heroCTALink
        heroCaption
      }
      headings {
        value
        depth
      }
      tableOfContents(maxDepth: 3)
    }
  }
`

export default MainPage
